import { Link } from "react-router-dom";
import { Instagram, Music2, Youtube, Facebook, Linkedin, Mail, MapPin } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const { config, isPreview } = useSite();
  const c = config || {};
  const show = (k) => isPreview || c[k] !== false;
  return (
    <footer className="border-t border-border bg-background relative" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-sm bg-primary" />
            <span className="font-display font-black text-2xl tracking-tighter">INFLUCAST</span>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-md">
            {c.slogan || "La red nacional de influencia, contenido y producción que conecta marcas con la Bolivia real."}
          </p>
          <div className="flex gap-3 mt-6">
            {c.instagram && <a href={c.instagram} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-border flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors"><Instagram className="w-4 h-4" /></a>}
            {c.tiktok && <a href={c.tiktok} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-border flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors"><Music2 className="w-4 h-4" /></a>}
            {c.youtube && <a href={c.youtube} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-border flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors"><Youtube className="w-4 h-4" /></a>}
            {c.facebook && <a href={c.facebook} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-border flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors"><Facebook className="w-4 h-4" /></a>}
            {c.linkedin && <a href={c.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin" className="w-9 h-9 rounded-full border border-border flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors"><Linkedin className="w-4 h-4" /></a>}
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest mb-4">Sitio</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-muted-foreground hover:text-foreground">Home</Link></li>
            {show("nav_show_about") && <li><Link to="/quienes-somos" className="text-muted-foreground hover:text-foreground">Quiénes Somos</Link></li>}
            {show("nav_show_services") && <li><Link to="/servicios" className="text-muted-foreground hover:text-foreground">Servicios</Link></li>}
            {show("nav_show_talents") && <li><Link to="/talentos" className="text-muted-foreground hover:text-foreground">Talentos</Link></li>}
            {show("nav_show_products") && <li><Link to="/productos" className="text-muted-foreground hover:text-foreground">Productos</Link></li>}
            {show("nav_show_contact") && <li><Link to="/contacto" className="text-muted-foreground hover:text-foreground">Contacto</Link></li>}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest mb-4">Contacto</h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            {c.email && <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 shrink-0" /><a href={`mailto:${c.email}`} className="hover:text-foreground">{c.email}</a></li>}
            {c.whatsapp && <li className="flex items-start gap-2"><span className="font-bold text-foreground">W</span><a href={`https://wa.me/${(c.whatsapp || "").replace(/\D/g, "")}`} className="hover:text-foreground">{c.whatsapp}</a></li>}
            {c.address && <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0" />{c.address}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-6 px-6 lg:px-10 text-center text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} INFLUCAST · www.influcastbo.com · Hecho en Bolivia · </span>
        <Link to="/admin/login" data-testid="footer-admin-link" className="opacity-50 hover:opacity-100 hover:text-primary transition-opacity uppercase tracking-widest font-semibold">
          Admin
        </Link>
      </div>
    </footer>
  );
}
